export const validation = {
  otp: "Please enter a OTP",
};
